/* MEMBERS · El alta de socio (Daniel, 23-ago-2026).
 *
 * Manda el formulario al portal, que es quien crea el cliente en Shopify y lo suscribe en Klaviyo.
 * Aquí solo se valida lo justo para no hacer viajar una petición que ya se sabe que va a fallar, y
 * se enseña el resultado.
 *
 * ⚠️ LO QUE SE VALIDA AQUÍ NO PROTEGE NADA. El servidor vuelve a comprobarlo todo por su cuenta, y
 * es el suyo el que manda: cualquiera puede saltarse este fichero. Esto existe para que la persona
 * vea el error al lado del campo en vez de después de esperar.
 *
 * ⚠️ SÍ SE DICE SI EL CORREO YA TENÍA CUENTA, y es una decisión de Daniel (23-ago-2026): "mucha
 * gente le va a dar a Join Now sin saber que ya tiene una cuenta; hay que avisarle". Se le explicó
 * que un formulario que contesta distinto deja comprobar quién es cliente probando correos, y lo
 * mantuvo. El freno es el cupo de 5 por minuto y por IP del servidor.
 *
 * Lo que el servidor manda es un sí o un no, y nada más: ni el nombre de esa persona, ni sus
 * pedidos, ni el propio correo de vuelta. Los dos textos viven en el Liquid para que los cambie él.
 */
(function () {
  var form = document.getElementById('altaSocio');
  if (!form) return;

  var endpoint = form.getAttribute('data-endpoint') || 'https://returns.casdeia.com/exec';
  var txt = function (k) { return form.getAttribute('data-txt-' + k) || ''; };
  var caja = form.parentNode;
  var hecho = caja.querySelector('[data-alta-hecho]');
  var aviso = form.querySelector('[data-alta-aviso]');
  var boton = form.querySelector('.alta__btn');
  var textoBoton = boton ? boton.textContent : '';

  // ── los botones de sexo ─────────────────────────────────────────────────────────────────────
  var oculto = document.getElementById('altaSexo');
  form.querySelectorAll('.alta__op').forEach(function (b) {
    b.addEventListener('click', function () {
      form.querySelectorAll('.alta__op').forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
      b.setAttribute('aria-pressed', 'true');
      oculto.value = b.getAttribute('data-valor');
      limpiar('altaSexo');
    });
  });

  // ── errores al lado del campo ───────────────────────────────────────────────────────────────
  function pinta(id, mensaje) {
    var p = form.querySelector('.alta__err[data-para="' + id + '"]');
    if (p) p.textContent = mensaje || '';
    var campo = document.getElementById(id);
    if (campo) campo.classList.toggle('alta__in--mal', !!mensaje);
  }
  function limpiar(id) { pinta(id, ''); }

  // La misma comprobación de forma que hace el servidor. No valida que el correo exista: eso lo dirá
  // el código que Shopify le mande.
  function pareceEmail(v) {
    var s = String(v || '').trim();
    if (s.length < 6 || s.length > 254 || /\s/.test(s)) return false;
    return /^[^@\s]+@[^@\s.]+(\.[^@\s.]+)+$/.test(s);
  }

  ['altaNombre', 'altaEmail'].forEach(function (id) {
    var c = document.getElementById(id);
    if (c) c.addEventListener('input', function () { limpiar(id); });
  });
  var telCampo = document.getElementById('altaTel');
  if (telCampo) telCampo.addEventListener('input', function () { limpiar('altaTel'); });

  // El teléfono, montado como en el newsletter del pie: prefijo del desplegable + solo los dígitos,
  // sin ceros por delante. Devuelve '' si no escribió nada (es opcional) y null si lo escrito no
  // puede ser un teléfono: el servidor repite esta misma comprobación por su cuenta.
  function telefonoCompleto() {
    if (!telCampo) return '';
    var num = (telCampo.value || '').replace(/[^0-9]/g, '').replace(/^0+/, '');
    if (!num) return '';
    if (num.length < 6 || num.length > 14) return null;
    var cc = document.getElementById('altaCc');
    return (cc ? cc.value : '+34') + num;
  }
  ['altaDia', 'altaMes'].forEach(function (id) {
    var c = document.getElementById(id);
    if (c) c.addEventListener('change', function () { limpiar('altaDia'); });
  });

  function valida() {
    var malo = null;
    var nombre = document.getElementById('altaNombre');
    var email = document.getElementById('altaEmail');
    var dia = document.getElementById('altaDia');
    var mes = document.getElementById('altaMes');

    if (!nombre.value.trim()) { pinta('altaNombre', txt('falta')); malo = malo || nombre; }
    if (!email.value.trim()) { pinta('altaEmail', txt('falta')); malo = malo || email; }
    else if (!pareceEmail(email.value)) { pinta('altaEmail', txt('email')); malo = malo || email; }
    if (!oculto.value) { pinta('altaSexo', txt('sexo')); malo = malo || form.querySelector('.alta__op'); }
    if (!dia.value || !mes.value) { pinta('altaDia', txt('cumple')); malo = malo || dia; }
    if (telefonoCompleto() === null) { pinta('altaTel', txt('tel')); malo = malo || telCampo; }

    // Al primero que esté mal, no al último: si no, la pantalla salta al final del formulario y
    // parece que el error está ahí.
    if (malo && malo.focus) {
      try { malo.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) { malo.scrollIntoView(); }
      malo.focus({ preventScroll: true });
    }
    return !malo;
  }

  // ── enviar ──────────────────────────────────────────────────────────────────────────────────
  var enviando = false;
  form.addEventListener('submit', function (ev) {
    ev.preventDefault();
    if (enviando) return;
    aviso.textContent = '';
    if (!valida()) return;

    enviando = true;
    boton.disabled = true;
    boton.textContent = txt('enviando');

    var cuerpo = {
      action: 'members-registro',
      nombre: document.getElementById('altaNombre').value,
      apellido: document.getElementById('altaApellido').value,
      email: document.getElementById('altaEmail').value.trim().toLowerCase(),
      sexo: oculto.value,
      dia: document.getElementById('altaDia').value,
      mes: document.getElementById('altaMes').value,
      anio: document.getElementById('altaAnio').value,
      telefono: telefonoCompleto() || '',
      newsletter: document.getElementById('altaNews').checked
    };

    // text/plain a propósito: petición "simple", sin comprobación previa del navegador. Igual que en
    // la lista de deseos.
    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
      body: JSON.stringify(cuerpo)
    })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; })
      .then(function (res) {
        enviando = false;
        boton.disabled = false;
        boton.textContent = textoBoton;

        if (res && res.ok) { terminar(cuerpo.email, !!res.yaExistia); return; }

        // Errores de campo: se pintan donde toca en vez de en un aviso general, que es donde nadie
        // los relaciona con nada.
        var e = res && res.error;
        if (e === 'email') { pinta('altaEmail', txt('email')); return; }
        if (e === 'nombre') { pinta('altaNombre', txt('falta')); return; }
        if (e === 'sexo') { pinta('altaSexo', txt('sexo')); return; }
        if (e === 'cumple' || e === 'anio') { pinta('altaDia', txt('cumple')); return; }
        if (e === 'telefono') { pinta('altaTel', txt('tel')); return; }

        aviso.textContent = txt('fallo');
        try { aviso.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (err) { /* da igual */ }
      });
  });

  function terminar(email, yaExistia) {
    var donde = hecho.querySelector('[data-alta-email]');
    if (donde) donde.textContent = email;
    // Dos carteles: no es lo mismo estrenar cuenta que descubrir que ya tenías una. El servidor solo
    // dice sí o no; el texto vive en el Liquid para que Daniel lo pueda cambiar.
    ['[data-alta-titulo]', '[data-alta-texto]'].forEach(function (sel) {
      var n = hecho.querySelector(sel);
      if (n) n.textContent = n.getAttribute(yaExistia ? 'data-vieja' : 'data-nueva') || n.textContent;
    });
    form.classList.add('members--oculto');
    hecho.classList.remove('members--oculto');
    try { caja.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) { /* da igual */ }
  }
})();
